import React, { memo } from 'react';
import { Table, Box, Space, Flex, Title } from '@mantine/core';
// import classes from "./ProducTable.module.css"

interface ProductTableProps {
    data?: any;
}

const TablePallet: React.FC<ProductTableProps> = ({
    data
}) => {


    const rows = data?.map((el: any, index: number) => (
        <Table.Tr key={el.id}>
            <Table.Td>{index + 1}</Table.Td>
            <Table.Td>{el?.Pallet?.pallet_name}</Table.Td>
            <Table.Td>{el?.no_of_box}</Table.Td>
        </Table.Tr>
    ));

    return (
        <div style={{ padding: '10px' }}>
            <Box style={{ background: '#40404010' }} p={'sm'}>
                <Flex
                    gap="md"
                    justify="space-between"
                    align="center"
                    direction="row"
                    wrap="wrap"

                >
                    {/* <Title order={3}>{datalist?.data?.rows[0]?.product_name}</Title> */}
                    <Title order={3}>Pallet</Title>
                </Flex>
            </Box>
            <Space h={'md'} />
            {/* Table */}

                <Table striped verticalSpacing="md">
                    {/* <Table striped className={classes.customtable}> */}
                    <Table.Thead>
                        <Table.Tr style={{ backgroundColor: '#4040401A' }}>
                            <Table.Th>S No.</Table.Th>
                            <Table.Th>Package Box Name</Table.Th>
                            <Table.Th>No. of Box</Table.Th>
                        </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>{rows}</Table.Tbody>
                </Table>
            {/* {getlistError && <p style={{ color: 'red' }}>Error: {getlistError.message}</p>} */}

        </div>
    );
}

export default memo(TablePallet);
